export const StaffComment = ({ children }) => {
    return (
        <section className='mx-2 relative mt-16 mb-8 text-sub md:text-sm flex justify-center'>
            {' '}
            <img
                className='absolute top-0 -translate-y-1/2 left max-w-full z-10'
                src={`${process.env.PUBLIC_URL}/images/characters/dlc/comment_cap-fr.webp`}
                alt='unique characters you encounter on your journey'
            />
            <div className='frame w-full'>
                <div className='font-humming'>{children}</div>
            </div>
        </section>
    )
}
